module.exports = {
  'Prescribing':'MEDICATIONS.V2.FORM.OPTION.STAGE_ERRORS.PRESCRIBING',
  'Preparation of medicines in all locations / dispensing in a pharmacy':'MEDICATIONS.V2.FORM.OPTION.STAGE_ERRORS.MEDICING_PREPARATION',
  'Administration / supply of a medicine from a clinical area':'MEDICATIONS.V2.FORM.OPTION.STAGE_ERRORS.ADMINISTRATION',
  'Monitoring / follow-up of medicine use':'MEDICATIONS.V2.FORM.OPTION.STAGE_ERRORS.MONITORING',
  'Advice':'MEDICATIONS.V2.FORM.OPTION.STAGE_ERRORS.ADVICE',
  'Supply or use of over-the-counter (OTC) medicine':'MEDICATIONS.V2.FORM.OPTION.STAGE_ERRORS.OTC_SUPPLY',
  'Other':'MEDICATIONS.V2.FORM.OPTION.STAGE_ERRORS.OTHER'
};
